<template>
  <head-child
    class="themed-top-search"
    :class="headerClass"
    :change="variant === 'overlay'"
    :theme-color="themeColor"
    no-right
  >
    <template #left>
      <template v-if="showBack || showLocation">
        <button
          v-if="showBack"
          type="button"
          class="themed-top-search__back"
          aria-label="返回"
          @click="$emit('back')"
        >
          <van-icon name="arrow-left" size="1.35rem" />
        </button>
        <div
          v-else-if="showLocation"
          class="themed-top-search__location"
          @click="$emit('location')"
        >
          <van-icon name="location-o" size="0.9rem" />
          <span class="themed-top-search__location-text ellipsis">{{ locationText }}</span>
          <van-icon name="arrow-down" size="0.65rem" />
        </div>
      </template>
    </template>
    <template #middle>
      <van-search
        ref="searchInput"
        v-model="searchValue"
        class="themed-top-search__input"
        :placeholder="placeholder"
        shape="round"
        background="transparent"
        :clearable="clearable"
        :readonly="readonly"
        @focus="handleFocus"
        @search="handleSearch"
        @click.native="handleClick"
        @clear="$emit('clear')"
      />
    </template>
  </head-child>
</template>

<script>
import HeadChild from '@/components/HeadChild.vue'

export default {
  name: 'SearchHeader',
  components: { HeadChild },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '搜索商品',
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    showLocation: {
      type: Boolean,
      default: false,
    },
    locationText: {
      type: String,
      default: '定位中...',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    /** overlay：叠在 Banner 上；plain：白底页 */
    variant: {
      type: String,
      default: 'plain',
    },
    themeColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchValue: this.value,
    }
  },
  computed: {
    headerClass() {
      return {
        'themed-top-search--plain': this.variant === 'plain',
        'themed-top-search--search-only': !this.showBack && !this.showLocation,
      }
    },
  },
  watch: {
    value(val) {
      this.searchValue = val
    },
    searchValue(val) {
      this.$emit('input', val)
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.focus())
    }
  },
  methods: {
    focus() {
      const field = this.$refs.searchInput
      if (!field) return
      if (typeof field.focus === 'function') {
        field.focus()
        return
      }
      const input = field.$el && field.$el.querySelector('input')
      if (input) input.focus()
    },
    handleFocus() {
      this.$emit('focus')
    },
    handleClick() {
      if (this.readonly) {
        this.$emit('click')
      }
    },
    handleSearch() {
      this.$emit('search', this.searchValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/themedTopSearch.scss';
</style>
